const variables = {
	colors: {
		primary: '#262626',
		secondary: '#6366F1',
		lightPrimary: '#A6A6A6'
	}
};

export default variables;
